import React from "react";
import { Link } from "react-router-dom";
import Image from "../../../assets/image/image";
import HeaderCss from "./Header.css";

const HeaderTop = () => {
  return (
    <HeaderCss.HeaderTopContainer>
      <div className="Content">
        <Link to="/">
          <img src={Image.home} alt="home"></img>
          HOME
        </Link>
        <span>|</span>
        <Link to="/donation/register">정회원 신청</Link>
      </div>
    </HeaderCss.HeaderTopContainer>
  );
};

export default HeaderTop;
